/* Great Lakes Lavender Farm — UX bundle v2 (v2.3: per-plant line on companion trays; replaces gllf-ux-v1.js; v2.1 in gllf-perf-v1: lighter grouped grid; v2.2: lavender first). Layout and wording only; nothing is written to Shopify.
   1) Collections: when the shopper hasn't picked a "Sort by", the grid lists In stock first, then Pre-order, then
      Notify me / Sold out, with a small heading for each group. Works with every filter (each group is just Shopify's
      own results for the shopper's filters + the availability filter). Picking any "Sort by" shows Shopify's normal order.
   2) Collections: a "Hide notify me plants" switch (= Shopify's own "In stock" filter, so it combines with all filters).
      Smart Shop "Available Soonest" does the same.
   3) "Alerts saved on this browser": "Not now" now hides it for 30 days (it used to come back every visit).
   4) Phones: long collection descriptions fold to three lines ("More"); product pages show name + price above photos. */
(function () {
  'use strict';
  if (window.__gllfUxV2) return;
  window.__gllfUxV2 = true;
  var PHONE = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
  var AV = 'filter.v.availability';
  var html = document.documentElement;
  function q(s, r) { return (r || document).querySelector(s); }
  function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function store(k, v) { try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) { return null; } }
  var isCollection = /^\/collections\/[^/]+\/?$/.test(location.pathname);

  /* ---------- 1) In stock → Pre-order → Notify me ---------- */
  var tierRun = 0, inflight = null;
  function unwait() { html.classList.remove('gllf-tier-wait'); }
  function gridSectionId() {
    var c = q('#ProductGridContainer'), s = c && c.closest('.shopify-section');
    return s ? s.id.replace(/^shopify-section-/, '') : '';
  }
  function isPlantCatalog() { var c = q('[data-gllf-filter-config]'); return !!(q('nav.gllf-plant-filter') || q('[data-gllf-smart-shop][data-context="plants"]') || (c && /plant_ordering_status/.test(c.textContent))); }
  function fetchText(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); });
  }
  function readJson(text, attr) {
    var m = new RegExp('<script type="application/json" ' + attr + '>([\\s\\S]*?)</script>').exec(text || '');
    return m ? JSON.parse(m[1]) : null;
  }
  function cardsFrom(text) {
    var d = new DOMParser().parseFromString(text, 'text/html');
    return qa('#product-grid > li', d).filter(function (li) { return !li.classList.contains('gllf-tier-head'); });
  }
  function handleOf(li) {
    var a = q('a[href*="/products/"]', li), m = a && /\/products\/([^/?#]+)/.exec(a.getAttribute('href'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function head(title, sub, kind) {
    var li = document.createElement('li');
    li.className = 'gllf-tier-head gllf-tier-head--' + kind;
    li.innerHTML = '<h2 class="gllf-tier-head__t">' + esc(title) + '</h2>' + (sub ? '<p class="gllf-tier-head__s">' + esc(sub) + '</p>' : '');
    return li;
  }
  // Card skeleton (outer classes + list description) — used to check the light card section matches this grid.
  function sig(li) {
    if (!li) return '';
    var a = li.firstElementChild, b = a && a.firstElementChild;
    return [li.className, a && a.className, b && b.className, !!q('.wbproductdes', li)].join('|').replace(/\s+/g, ' ');
  }
  /* gllf-tier-cap-v1 */
  function tierCap() { return PHONE.matches ? 1 : 6; }
  function inMore(grid, o) {
    var li = document.createElement('li'); li.className = 'gllf-tier-moreli gllf-tier-moreli--in';
    var b = document.createElement('button'); b.type = 'button'; b.className = 'button button--secondary';
    function label() { b.textContent = o.label(Math.max(o.total - o.shown, 0)); }
    label();
    b.addEventListener('click', function () {
      b.disabled = true; o.page += 1;
      fetchText(o.pageUrl(o.page)).then(function (t) {
        var j = readJson(t, 'data-gllf-cards'); ((j && j.products) || []).forEach(function (p) { if (p && p.tone === 'pre') o.pre[p.handle] = 1; });
        var cards = cardsFrom(t), ph = q('.gllf-tier-head--pre', grid);
        cards.forEach(function (c) { var isPre = o.pre[handleOf(c)], n = document.adoptNode(c); grid.insertBefore(n, !isPre && ph && ph.parentNode === grid ? ph : li); });
        o.shown += cards.length; b.disabled = false;
        if (!cards.length || o.shown >= o.total) li.remove(); else label();
      }).catch(function () { b.disabled = false; o.page -= 1; });
    });
    li.appendChild(b); return li;
  }
  function tiers() {
    var grid = q('#product-grid'), sid = gridSectionId();
    var params = new URLSearchParams(location.search);
    var key = location.pathname + '?' + params.toString();
    if (!isCollection || !grid || !sid || params.get('sort_by') || (params.get('page') && params.get('page') !== '1')) { if (grid) grid.dataset.gllfTiered = key; unwait(); return; }
    if (grid.dataset.gllfTiered === key) { unwait(); return; }
    if (inflight && inflight.key === key && inflight.grid === grid) return;
    var av = params.getAll(AV);
    var onlyIn = av.indexOf('1') !== -1 && av.indexOf('0') === -1, onlyOut = av.indexOf('0') !== -1 && av.indexOf('1') === -1;
    if (onlyOut) { grid.dataset.gllfTiered = key; unwait(); return; }
    var run = ++tierRun;
    inflight = { key: key, grid: grid };
    var pageSig = sig(qa('#product-grid > li', grid).filter(function (li) { return !li.classList.contains('gllf-tier-head') && q('a[href*="/products/"]', li); })[0]);
    var base = new URLSearchParams(location.search);
    ['page', 'sort_by', 'section_id', AV].forEach(function (k) { base.delete(k); });
    function url(availability, section, page) {
      var p = new URLSearchParams(base.toString()); p.append(AV, availability); p.set('section_id', section); if (page > 1) p.set('page', String(page));
      return location.pathname + '?' + p.toString();
    }
    var plant = isPlantCatalog();
    // gllf-perf-v1: one light request per group (cards + statuses together). If its cards don't look like this
    // page's cards (a collection using a different template), fall back to the full grid section.
    var light = 'gllf-collection-cards';
    function viaLight() {
      return Promise.all([fetchText(url('1', light, 1)), onlyIn ? Promise.resolve('') : fetchText(url('0', light, 1))]).then(function (r) {
        var a = readJson(r[0], 'data-gllf-cards'), b = onlyIn ? { count: 0, products: [] } : readJson(r[1], 'data-gllf-cards');
        if (!a || !b) throw new Error('no cards');
        var aCards = cardsFrom(r[0]), bCards = onlyIn ? [] : cardsFrom(r[1]);
        var probe = aCards[0] || bCards[0];
        if (pageSig && probe && sig(probe) !== pageSig) return null; // different card style → use the grid section
        var inCount = +a.count || 0, pages = Math.min(Math.ceil(inCount / 24), tierCap()), more = [];
        for (var i = 2; i <= pages; i++) more.push(fetchText(url('1', light, i)));
        return Promise.all(more).then(function (rest) {
          var products = (a.products || []).slice();
          rest.forEach(function (t) { aCards = aCards.concat(cardsFrom(t)); var j = readJson(t, 'data-gllf-cards'); if (j) products = products.concat(j.products || []); });
          return { inCount: inCount, outCount: +b.count || 0, products: products, inCards: aCards, outCards: bCards, outSection: light, inPages: Math.max(pages, 1), inSection: light };
        });
      });
    }
    function viaGrid() {
      var jobs = [fetchText(url('1', 'gllf-collection-orderable', 1)), fetchText(url('1', sid, 1)),
        onlyIn ? Promise.resolve('') : fetchText(url('0', 'gllf-collection-count', 1)),
        onlyIn ? Promise.resolve('') : fetchText(url('0', sid, 1))];
      return Promise.all(jobs).then(function (r) {
        var info = readJson(r[0], 'data-gllf-orderable') || { count: 0, products: [] };
        var inCount = +info.count || 0, outCount = onlyIn ? 0 : (+readJson(r[2], 'data-gllf-count') || 0);
        var pages = Math.min(Math.ceil(inCount / 24), tierCap()), infoPages = Math.min(Math.ceil(inCount / 50), 3), more = [], moreInfo = [];
        for (var i = 2; i <= pages; i++) more.push(fetchText(url('1', sid, i)));
        for (var k = 2; k <= infoPages; k++) moreInfo.push(fetchText(url('1', 'gllf-collection-orderable', k)));
        return Promise.all(more.concat(moreInfo)).then(function (rest) {
          var products = (info.products || []).slice();
          rest.slice(more.length).forEach(function (t) { var j = readJson(t, 'data-gllf-orderable'); if (j) products = products.concat(j.products || []); });
          var inCards = cardsFrom(r[1]); rest.slice(0, more.length).forEach(function (t) { inCards = inCards.concat(cardsFrom(t)); });
          return { inCount: inCount, outCount: outCount, products: products, inCards: inCards, outCards: onlyIn ? [] : cardsFrom(r[3]), outSection: sid, inPages: Math.max(pages, 1), inSection: sid };
        });
      });
    }
    /* v2.2 Lavender first: in a plant collection that also holds companion perennials, lavender leads
       (in stock, then pre-order), companions follow in their own group, notify-me plants come last.
       Skipped when the shopper filtered by botanical group (they are looking for a specific kind of plant). */
    var ID = 'filter.p.m.custom.plant_identity_type', BG = 'filter.p.m.custom.botanical_group';
    var idVals = []; qa('input[name="' + ID + '"]').forEach(function (i) { if (i.value && idVals.indexOf(i.value) === -1) idVals.push(i.value); });
    // Every lavender identity type, including ones the filter list on this page may not show.
    if (idVals.length) ['Named Cultivar/Selection', 'Named Hybrid/Selection', 'Commercial Taxon Stock', 'Mystery/Farm Selection'].forEach(function (v) { if (idVals.indexOf(v) === -1) idVals.push(v); });
    var lavMode = plant && idVals.length && !base.getAll(BG).length && !base.getAll(ID).length;
    function lavUrl(page) {
      var p = new URLSearchParams(base.toString()); idVals.forEach(function (v) { p.append(ID, v); });
      p.append(AV, '1'); p.set('section_id', light); if (page > 1) p.set('page', String(page));
      return location.pathname + '?' + p.toString();
    }
    function moreRow(labelFn, loader) {
      var li = document.createElement('li'); li.className = 'gllf-tier-moreli';
      var b = document.createElement('button'); b.type = 'button'; b.className = 'button button--secondary'; b.textContent = labelFn();
      b.addEventListener('click', function () {
        b.disabled = true;
        loader().then(function (r) {
          r.cards.forEach(function (c) { li.parentNode.insertBefore(document.adoptNode(c), li); });
          b.disabled = false; if (r.done) li.remove(); else b.textContent = labelFn();
        }).catch(function () { b.disabled = false; });
      });
      li.appendChild(b); return li;
    }
    function lavFirst() {
      return Promise.all([fetchText(lavUrl(1)), fetchText(url('1', light, 1)), onlyIn ? Promise.resolve('') : fetchText(url('0', light, 1))]).then(function (r) {
        var lj = readJson(r[0], 'data-gllf-cards'), aj = readJson(r[1], 'data-gllf-cards'), oj = onlyIn ? { count: 0 } : readJson(r[2], 'data-gllf-cards');
        if (!lj || !aj || !oj) return false;
        var lavCount = +lj.count || 0, allCount = +aj.count || 0, compTotal = allCount - lavCount;
        if (!lavCount || compTotal <= 0) return false; // lavender only, or companions only → the normal grouped grid
        var lavCards = cardsFrom(r[0]), allCards = cardsFrom(r[1]), outCards = onlyIn ? [] : cardsFrom(r[2]);
        var probe = lavCards[0] || allCards[0];
        if (pageSig && probe && sig(probe) !== pageSig) return false;
        var pages = Math.min(Math.ceil(lavCount / 24), tierCap()), more = [];
        for (var i = 2; i <= pages; i++) more.push(fetchText(lavUrl(i)));
        return Promise.all(more).then(function (rest) {
          if (run !== tierRun) return true;
          var products = (lj.products || []).slice();
          rest.forEach(function (t) { lavCards = lavCards.concat(cardsFrom(t)); var j = readJson(t, 'data-gllf-cards'); if (j) products = products.concat(j.products || []); });
          var pre = {}, isLav = {}; products.forEach(function (p) { if (!p) return; isLav[p.handle] = 1; if (p.tone === 'pre') pre[p.handle] = 1; });
          (aj.products || []).forEach(function (p) { if (p && p.lav) isLav[p.handle] = 1; });
          var ready = lavCards.filter(function (li) { return !pre[handleOf(li)]; }), preCards = lavCards.filter(function (li) { return pre[handleOf(li)]; });
          var compCards = allCards.filter(function (li) { return !isLav[handleOf(li)]; });
          var frag = document.createDocumentFragment(), n = function (k, one, many) { return k + (k === 1 ? one : many); };
          if (ready.length) { frag.appendChild(head('Lavender in stock now', n(ready.length, ' plant', ' plants') + ' ready to order', 'in')); ready.forEach(function (li) { frag.appendChild(document.adoptNode(li)); }); }
          if (preCards.length) { frag.appendChild(head('Lavender pre-order', n(preCards.length, ' plant', ' plants') + ' you can reserve now', 'pre')); preCards.forEach(function (li) { frag.appendChild(document.adoptNode(li)); }); }
          (lavCards.length < lavCount && frag.appendChild(inMore(grid, { total: lavCount, shown: lavCards.length, page: Math.max(pages, 1), pre: pre, pageUrl: lavUrl, label: function (k) { return 'Show more lavender (' + k + ' more)'; } }))), frag.appendChild(head('Companion perennials', n(compTotal, ' plant', ' plants') + ' that grow alongside lavender. Order or reserve now.', 'comp'));
          compCards.forEach(function (li) { frag.appendChild(document.adoptNode(li)); });
          var compShown = compCards.length, compPage = 1, compPages = Math.ceil(allCount / 24);
          if (compShown < compTotal) frag.appendChild(moreRow(function () { return 'Show more companion plants (' + (compTotal - compShown) + ' more)'; }, function load() {
            compPage += 1;
            return fetchText(url('1', light, compPage)).then(function (t) {
              var j = readJson(t, 'data-gllf-cards'); ((j && j.products) || []).forEach(function (p) { if (p && p.lav) isLav[p.handle] = 1; });
              var cards = cardsFrom(t).filter(function (li) { return !isLav[handleOf(li)]; });
              compShown += cards.length;
              var done = compPage >= compPages || compShown >= compTotal;
              if (!cards.length && !done) return load(); // a page of lavender only → keep going
              return { cards: cards, done: done };
            });
          }));
          var outCount = +oj.count || 0;
          if (outCards.length) {
            frag.appendChild(head('Notify me when available', n(outCount, ' plant', ' plants') + ' coming later. Open one to get an alert.', 'out'));
            outCards.forEach(function (li) { frag.appendChild(document.adoptNode(li)); });
            var outShown = outCards.length, outPage = 1;
            if (outShown < outCount) frag.appendChild(moreRow(function () { return 'Show more plants (' + (outCount - outShown) + ' more)'; }, function () {
              outPage += 1;
              return fetchText(url('0', light, outPage)).then(function (t) { var cards = cardsFrom(t); outShown += cards.length; return { cards: cards, done: !cards.length || outShown >= outCount }; });
            }));
          }
          var old = q('.gllf-tier-more'); if (old) old.remove();
          grid.replaceChildren(frag);
          grid.dataset.gllfTiered = key;
          grid.classList.add('gllf-tiered');
          var pag = q('#ProductGridContainer .pagination'); if (pag) pag.hidden = true;
          return true;
        });
      });
    }
    var start = lavMode ? lavFirst().catch(function () { return false; }) : Promise.resolve(false);
    start.then(function (done) { return done ? null : viaLight().catch(function () { return null; }).then(function (d) { return d || viaGrid(); }); }).then(function (d) {
      if (run !== tierRun || !d) return null;
      var pre = {}; d.products.forEach(function (p) { if (p && p.tone === 'pre') pre[p.handle] = 1; });
      if (!d.inCount || (!d.outCount && !Object.keys(pre).length)) { grid.dataset.gllfTiered = key; return null; }
      var ready = d.inCards.filter(function (li) { return !pre[handleOf(li)]; }), preCards = d.inCards.filter(function (li) { return pre[handleOf(li)]; });
      var frag = document.createDocumentFragment(), outCount = d.outCount;
      if (ready.length) {
        frag.appendChild(head('In stock now', (d.inCards.length < d.inCount ? Math.max(ready.length, d.inCount - Object.keys(pre).length) : ready.length) + (ready.length === 1 && d.inCards.length >= d.inCount ? (plant ? ' plant' : ' item') : (plant ? ' plants' : ' items')) + ' ready to order', 'in'));
        ready.forEach(function (li) { frag.appendChild(document.adoptNode(li)); });
      }
      if (preCards.length) {
        frag.appendChild(head('Pre-order', preCards.length + (preCards.length === 1 ? ' plant' : ' plants') + ' you can reserve now', 'pre'));
        preCards.forEach(function (li) { frag.appendChild(document.adoptNode(li)); });
      }
      (d.inPages && d.inCards.length < d.inCount && frag.appendChild(inMore(grid, { total: d.inCount, shown: d.inCards.length, page: d.inPages, pre: pre, pageUrl: function (p) { return url('1', d.inSection, p); }, label: function (k) { return (plant ? 'Show more plants in stock (' : 'Show more in stock (') + k + ' more)'; } })));
      if (d.outCards.length) {
        frag.appendChild(head(plant ? 'Notify me when available' : 'Sold out', outCount + (plant ? (outCount === 1 ? ' plant' : ' plants') + ' coming later. Open one to get an alert.' : (outCount === 1 ? ' item' : ' items')), 'out'));
        d.outCards.forEach(function (li) { frag.appendChild(document.adoptNode(li)); });
      }
      grid.replaceChildren(frag);
      grid.dataset.gllfTiered = key;
      grid.classList.add('gllf-tiered');
      var pag = q('#ProductGridContainer .pagination'); if (pag) pag.hidden = true;
      showMore(grid, d.outCards.length, outCount, function (page) { return url('0', d.outSection, page); });
      return null;
    }).catch(function () { grid.dataset.gllfTiered = key; }).then(function () { if (run === tierRun) { inflight = null; unwait(); } });
  }
  function showMore(grid, shown, total, pageUrl) {
    var old = q('.gllf-tier-more'); if (old) old.remove();
    if (shown >= total) return;
    var page = 1;
    var wrap = document.createElement('div'); wrap.className = 'gllf-tier-more';
    var b = document.createElement('button'); b.type = 'button'; b.className = 'button button--secondary';
    function label() { b.textContent = 'Show more plants (' + (total - shown) + ' more)'; if (!isPlantCatalog()) b.textContent = 'Show more (' + (total - shown) + ' more)'; }
    label();
    b.addEventListener('click', function () {
      b.disabled = true; page += 1;
      fetchText(pageUrl(page)).then(function (t) {
        var cards = cardsFrom(t); cards.forEach(function (li) { grid.appendChild(document.adoptNode(li)); });
        shown += cards.length; b.disabled = false;
        if (!cards.length || shown >= total) wrap.remove(); else label();
      }).catch(function () { b.disabled = false; page -= 1; });
    });
    wrap.appendChild(b);
    grid.insertAdjacentElement('afterend', wrap);
  }

  /* "Recommended" = the grouped order above; any other Sort by choice = Shopify's order. */
  function sortOption() {
    if (!isCollection) return;
    var none = !new URLSearchParams(location.search).get('sort_by');
    qa('select[name="sort_by"]').forEach(function (sel) {
      if (q('option[value=""]', sel)) return; // already done for this (re)drawn menu; never undo the shopper's own choice
      var o = document.createElement('option'); o.value = ''; o.textContent = 'Recommended'; sel.insertBefore(o, sel.firstChild);
      if (none) sel.value = '';
    });
  }

  /* ---------- 2) Hide notify me plants switch ---------- */
  function setInStock(on) {
    var boxes = qa('input[name="' + AV + '"][value="1"]');
    if (boxes.length) {
      boxes.forEach(function (b) { b.checked = on; });
      var form = q('#FacetFiltersForm') ? q('#FacetFiltersForm input[name="' + AV + '"][value="1"]') : boxes[0];
      if (PHONE.matches && q('#FacetFiltersFormMobile input[name="' + AV + '"][value="1"]')) form = q('#FacetFiltersFormMobile input[name="' + AV + '"][value="1"]');
      if (form) { form.dispatchEvent(new Event('input', { bubbles: true })); return; }
    }
    var u = new URL(location.href), vals = u.searchParams.getAll(AV).filter(function (v) { return v !== '1'; });
    u.searchParams.delete(AV); u.searchParams.delete('page');
    if (on) u.searchParams.append(AV, '1'); else vals.forEach(function (v) { u.searchParams.append(AV, v); });
    location.href = u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '');
  }
  function inStockOn() { return new URLSearchParams(location.search).getAll(AV).indexOf('1') !== -1; }
  function stockSwitch() {
    if (!isCollection) return;
    var bar = q('.wbsortbar') || (q('#ProductGridContainer') && q('#ProductGridContainer').parentElement); if (!bar) return;
    if (!qa('input[name="' + AV + '"]').length && !q('[data-gllf-filter-config]')) return;
    var sw = q('.gllf-stock-switch');
    if (!sw) {
      sw = document.createElement('label'); sw.className = 'gllf-stock-switch';
      sw.innerHTML = '<input type="checkbox" role="switch"><span class="gllf-stock-switch__ui" aria-hidden="true"></span><span class="gllf-stock-switch__t"></span>';
      q('input', sw).addEventListener('change', function (e) { setInStock(e.target.checked); });
      bar.insertBefore(sw, bar.firstChild);
    }
    var label = q('.gllf-stock-switch__t', sw), text = isPlantCatalog() ? 'Hide notify me plants' : 'Hide sold out items';
    if (label.textContent !== text) label.textContent = text; // only when it changes (setting it is itself a page change we watch for)
    q('input', sw).checked = inStockOn();
  }
  function soonest() {
    qa('[data-gllf-ux-soonest]').forEach(function (b) {
      if (b.dataset.bound) return; b.dataset.bound = '1';
      b.setAttribute('aria-pressed', String(inStockOn()));
      b.addEventListener('click', function () { setInStock(!inStockOn()); });
    });
  }

  /* ---------- 3) "Alerts saved on this browser": Not now = 30 days ---------- */
  var SNOOZE = 'gllfGuestMergeSnooze';
  function mergeNotice(n) {
    if (!n || n.dataset.uxDone) return; n.dataset.uxDone = '1';
    if (+(store(SNOOZE) || 0) > Date.now()) { try { window.sessionStorage.setItem('gllf_guest_merge_decided_v32', 'dismissed'); } catch (e) {} n.remove(); return; }
    var skip = q('[data-skip-merge]', n);
    if (skip) skip.addEventListener('click', function () { store(SNOOZE, String(Date.now() + 30 * 864e5)); });
    if (!q('.gllf-ux-merge-x', n) && skip) {
      var x = document.createElement('button'); x.type = 'button'; x.className = 'gllf-ux-merge-x'; x.setAttribute('aria-label', 'Hide for 30 days'); x.innerHTML = '&times;';
      x.addEventListener('click', function () { skip.click(); });
      n.appendChild(x);
    }
  }
  function watchMerge() {
    mergeNotice(q('[data-gllf-guest-merge]'));
    new MutationObserver(function (list) {
      list.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, function (n) { if (n.nodeType === 1 && n.hasAttribute('data-gllf-guest-merge')) mergeNotice(n); }); });
    }).observe(document.body, { childList: true });
  }

  /* ---------- 4) Phones: description fold, product summary ---------- */
  function foldDescription() {
    var d = q('.collection-hero__description'); if (!d || d.dataset.uxFold) return;
    if (!PHONE.matches || d.scrollHeight < 120) return;
    d.dataset.uxFold = '1'; d.classList.add('gllf-ux-fold', 'is-folded');
    var b = document.createElement('button'); b.type = 'button'; b.className = 'gllf-ux-more'; b.textContent = 'More'; b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () { var open = d.classList.toggle('is-folded') === false; b.textContent = open ? 'Less' : 'More'; b.setAttribute('aria-expanded', String(open)); });
    d.insertAdjacentElement('afterend', b);
  }
  function productSummary() {
    if (!/^\/products\//.test(location.pathname)) return;
    var info = q('product-info[id^="MainProduct-"]'); if (!info || q('.gllf-ux-msum', info)) return;
    var h1 = q('h1', info), media = q('.proplightb', info) || (q('media-gallery', info) && q('media-gallery', info).closest('.grid__item')); if (!h1 || !media) return;
    var sid = info.id.replace('MainProduct-', ''), priceEl = document.getElementById('price-' + sid);
    var box = document.createElement('div'); box.className = 'gllf-ux-msum'; box.setAttribute('aria-hidden', 'true');
    var last = '';
    function name() { return String(h1.textContent || '').replace(/\s+/g, ' ').trim(); }
    function price() {
      if (!priceEl) return '';
      var sale = q('.price__sale .price-item--sale, .price-item--sale', priceEl), reg = q('.price__regular .price-item--regular, .price-item--regular', priceEl);
      return String(((sale && sale.offsetParent !== null ? sale : reg) || priceEl).textContent || '').replace(/\s+/g, ' ').trim();
    }
    function draw() {
      var parts = name().split(/\s+-\s+/), chip = q('.gllf-po-chip', info);
      var h = '<p class="gllf-ux-msum__name">' + esc(parts[0]) + '</p>' + (parts[1] ? '<p class="gllf-ux-msum__bot">' + esc(parts.slice(1).join(' - ')) + '</p>' : '') +
        '<div class="gllf-ux-msum__row"><span class="gllf-ux-msum__price">' + esc(price()) + '</span>' + (chip ? '<span class="gllf-ux-chip gllf-ux-chip--pre">' + esc(chip.textContent) + '</span>' : '') + '</div>';
      if (h !== last) { last = h; box.innerHTML = h; } // only touch the DOM when something changed (the observer sees our own edits too)
    }
    draw();
    media.insertAdjacentElement('beforebegin', box);
    var pending = false;
    new MutationObserver(function () { if (pending) return; pending = true; requestAnimationFrame(function () { pending = false; draw(); }); })
      .observe(info, { childList: true, subtree: true, characterData: true });
  }

  /* Re-apply after the theme redraws the grid (filters, Smart Shop, back/forward). */
  function collectionUi() { sortOption(); stockSwitch(); soonest(); tiers(); }
  function watchGrid() {
    var main = q('#MainContent') || document.body, t;
    // Throttle (not debounce): other scripts change the page all the time, which would keep a debounce from ever firing.
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () {
        t = 0;
        var g = q('#product-grid');
        if (g && !g.dataset.gllfTiered && !(inflight && inflight.grid === g) && !new URLSearchParams(location.search).get('sort_by')) html.classList.add('gllf-tier-wait');
        collectionUi();
      }, 60);
    }).observe(main, { childList: true, subtree: true });
    window.addEventListener('popstate', function () { setTimeout(collectionUi, 300); });
  }

  /* v2.3: "per plant" line on companion plug trays. Display only: it divides prices the page already shows by the
     tray size in the title ("... - 72-Cell Plug Tray"). Follows the quantity-discount tier and the wholesale choice. */
  var TRAY = /-\s*(\d+)-Cell Plug Tray\s*$/i;
  function ppCents(t) { var m = String(t || '').replace(/,/g, '').match(/\$\s*(\d+(?:\.\d{1,2})?)/); return m ? Math.round(parseFloat(m[1]) * 100) : 0; }
  function ppMoney(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function ppShown(root) {
    var box = q('.price', root); if (!box) return 0;
    var el = (/price--on-sale/.test(box.className) && q('.price__sale .price-item--sale', box)) || q('.price__regular .price-item--regular', box);
    return ppCents(el && el.textContent);
  }
  function ppStyle() {
    if (q('#gllf-pp-style')) return;
    var st = document.createElement('style'); st.id = 'gllf-pp-style';
    st.textContent = '.gllf-pp{margin:4px 0 0;font-size:16px;line-height:1.35;color:#4a3560;font-weight:600}' +
      '.gllf-pp small{display:block;font-size:16px;font-weight:400;color:#4b4b4b}' +
      '.gllf-pp--pdp{margin:8px 0 2px;padding:8px 12px;border-left:4px solid #b89b4a;background:#f7f3fa;border-radius:6px;font-size:18px}' +
      '.gllf-pp-tier{display:block;font-size:16px;font-weight:600;color:#4a3560}' +
      '.gllf-pp--lead{font-weight:400;color:#1f1f1f}.gllf-pp--lead strong{font-size:18px;font-weight:700}.gllf-pp--lead s{color:#5a5a5a}' +
      '.gllf-pp-swap{display:none!important}';
    document.head.appendChild(st);
  }
  function perPlantCards() {
    qa('.card-wrapper').forEach(function (card) {
      if (card.dataset.gllfPp === '0' || q('.gllf-pp', card)) return;
      var a = q('.card__heading a', card), m = a && TRAY.exec(a.textContent.trim());
      if (!m) { card.dataset.gllfPp = '0'; return; }
      var n = parseInt(m[1], 10), holder = q('.card-information', card) || q('.card__information', card), c = ppShown(holder || card);
      if (!n || !c || !holder) return;
      ppStyle();
      var price = q('.price', holder), was = price && /price--on-sale/.test(price.className) ? ppCents((q('.price__sale .price-item--regular', price) || {}).textContent) : 0;
      var p = document.createElement('p'); p.className = 'gllf-pp gllf-pp--lead';
      p.innerHTML = '<strong>' + esc(ppMoney(Math.round(c / n))) + '</strong>' + (was > c ? ' <s><span class="visually-hidden">was </span>' + esc(ppMoney(Math.round(was / n))) + '</s>' : '') + ' per plant' +
        '<small>' + esc(ppMoney(c)) + ' per tray of ' + n + '</small>';
      var wrap = price && (price.closest('.wbhprice') || price);
      if (wrap && wrap.parentNode) { wrap.classList.add('gllf-pp-swap'); wrap.parentNode.insertBefore(p, wrap); } else holder.appendChild(p);
    });
  }
  function perPlantProduct() {
    var info = q('product-info[id^="MainProduct-"]'); if (!info || info.dataset.gllfPp) return;
    var h = q('h1', info), m = h && TRAY.exec(h.textContent.trim()); if (!m) return;
    var n = parseInt(m[1], 10); if (!n) return;
    info.dataset.gllfPp = '1'; ppStyle();
    var line = document.createElement('p'); line.className = 'gllf-pp gllf-pp--pdp'; line.setAttribute('aria-live', 'polite');
    var last = '';
    function draw() {
      var priceBox = q('.mainp-price', info) || q('[id^="price-"]', info); if (!priceBox) return;
      var base = ppShown(priceBox); if (!base) return;
      if (line.previousElementSibling !== priceBox) priceBox.insertAdjacentElement('afterend', line);
      qa('.gllf-bulk__tier', info).forEach(function (t) {
        var c = ppCents((q('.gllf-bulk__price', t) || {}).textContent), tag = q('.gllf-pp-tier', t), txt = c ? ppMoney(Math.round(c / n)) + ' a plant' : '';
        if (!txt) return;
        if (!tag) { tag = document.createElement('span'); tag.className = 'gllf-pp-tier'; t.appendChild(tag); }
        if (tag.textContent !== txt) tag.textContent = txt;
      });
      var ws = q('.gllf-po-wholesale[aria-pressed="true"]', info), act = q('.gllf-bulk__tier.is-active', info), html;
      if (ws) {
        var w = Math.round(base / 2);
        html = esc(ppMoney(Math.round(w / n))) + ' per plant wholesale<small>' + esc(ppMoney(w)) + ' wholesale per tray · ' + n + ' plants per tray</small>';
      } else {
        var c = act ? ppCents((q('.gllf-bulk__price', act) || {}).textContent) : 0, save = act && !/is-base/.test(act.className) ? (q('.gllf-bulk__save', act) || {}).textContent : '';
        if (!c) { c = base; save = ''; }
        html = esc(ppMoney(Math.round(c / n))) + ' per plant<small>' + (save ? esc(ppMoney(c)) + ' per tray at this quantity (' + esc(String(save).trim()) + ') · ' : '') + n + ' plants per tray</small>';
      }
      if (html !== last) { last = html; line.innerHTML = html; }
    }
    draw();
    var pending = false;
    new MutationObserver(function () { if (pending) return; pending = true; setTimeout(function () { pending = false; draw(); }, 60); })
      .observe(info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'aria-pressed'] });
  }
  function perPlant() { perPlantCards(); perPlantProduct(); }
  function watchPerPlant() {
    var t; new MutationObserver(function () { if (t) return; t = setTimeout(function () { t = 0; perPlant(); }, 200); })
      .observe(document.body, { childList: true, subtree: true });
  }


  function boot() {
    watchMerge();
    perPlant(); watchPerPlant();
    foldDescription(); productSummary();
    if (isCollection) { collectionUi(); watchGrid(); } else unwait();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  setTimeout(productSummary, 1500);
  setTimeout(unwait, 6000);
})();
;(function(){try{if(window.__gllfGcpL729)return;window.__gllfGcpL729=1;window.__gllfGcpL724=1;var c=document.currentScript,b=c&&c.src?c.src.replace(/gllf-ux-v2\.js.*$/,""):"";if(!b||b===c.src)return;function go(){if(!document.querySelector("section[data-gch][data-post-url],section[data-gcd],[data-gllf-events],#gllf-dir"))return;var x=document.createElement("script");x.src=b+"gllf-community-places.js?v=20261126a";x.defer=true;document.head.appendChild(x);}if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",go);else go();}catch(e){}})(); /* v2026-11-05: Grower Community and Farm Day Trips */
;(function(){try{if(window.GLLFCapture||document.querySelector('script[src*="gllf-capture.js"]'))return;var me=document.querySelector('script[src*="gllf-ux-v2.js"]');if(!me)return;var s=document.createElement('script');s.src=(window.gllfAssets&&window.gllfAssets["gllf-capture.js"])||me.src.replace(/gllf-ux-v2\.js.*$/,'gllf-capture.js?v=20261125a');s.defer=true;document.head.appendChild(s);}catch(e){}})(); /* v746: Camera and Check in in the phone menu */
